import * as React from 'react'
import { TextInput } from '../../components/UI/TextInput'
import { Button } from '../../components/UI/Button'
import { useForm } from '../../lib/hooks/useForm'
import { DisturberProps, INewsLetterValues } from './types'
import {
  StyledBody,
  StyledDescription,
  StyledDisturber,
  StyledErrorMessage,
  StyledForm,
  StyledHeader,
  StyledHeadline,
  StyledInput,
  StyledSuccessMessage,
  StyledWrapper,
} from './styled'
import useEventTracking from '../../lib/hooks/tracking'
import { sbEditable } from '@storyblok/storyblok-editable'

export const NewsletterDisturber = ({ blok }: { blok: DisturberProps }) => {
  const formRef = React.useRef(null)
  const trackEvent = useEventTracking()

  const { handleSubmit, status, statusCode, message } = useForm<INewsLetterValues>({
    form: formRef.current,
    // TODO: Remove once API allows payload without it
    additionalData: {
      firstname: '',
      lastname: '',
      // TODO: Add language dynamically
      language: 'English',
    },
    onSuccess: formData => {
      trackEvent('newsletter_subscribed', {contact_email: formData.email});
    },
  })
  const theme = blok.theme || 'bluetiful'

  return (
    <StyledWrapper className={theme && `theme-${theme}`} {...sbEditable(blok)}>
      <StyledDisturber>
        <StyledHeader>
          <StyledHeadline>{blok.headline}</StyledHeadline>
        </StyledHeader>
        <StyledBody>
          {status === 'success' ? (
            <StyledSuccessMessage>{blok.confirmationText}</StyledSuccessMessage>
          ) : (
            <>
              <StyledDescription>{blok.description}</StyledDescription>
              <StyledForm
                action={`${process.env.GATSBY_PDFTOOLS_API_URL}/Newsletter/Subscribe/Default`}
                onSubmit={handleSubmit}
                method="POST"
                ref={formRef}
                autoComplete="off"
              >
                <StyledInput>
                  <TextInput name="email" type="email" variant="dark" label={blok.inputPlaceholderText} required />
                  <Button $inverted={true} $size="small" type="submit" disabled={status === 'loading'}>
                    {blok.buttonText}
                  </Button>
                </StyledInput>
                {status === 'error' && statusCode === 400 && (
                  <StyledErrorMessage>{blok.invalidBodyData}</StyledErrorMessage>
                )}
                {status === 'error' && statusCode === 404 && (
                  <StyledErrorMessage>{blok.newsletterUnknown}</StyledErrorMessage>
                )}
                {status === 'error' && statusCode === 406 && (
                  <StyledErrorMessage>{blok.userAlreadyExists}</StyledErrorMessage>
                )}
                {status === 'error' && statusCode === 500 && (
                  <StyledErrorMessage>{blok.unknownErrorOccurred}</StyledErrorMessage>
                )}
              </StyledForm>
            </>
          )}
        </StyledBody>
      </StyledDisturber>
    </StyledWrapper>
  )
}
